import { Environment } from '@galaxy/core';

export const MAX_RECORDING_TIME = 150_000; // 2 min 30s - hard cap matching the batch UX from master
export const SILENCE_AUTO_STOP_MS = 8_000; // 8s without audio above threshold triggers auto-stop
export const TRANSCRIPTION_FLUSH_DELAY_MS = 2_000; // Safety upper bound for the flush window. The parent normally closes much sooner via completeFlush() on isFinal/isUtteranceEnd; this only matters when backend never emits a closing event.
export const STREAMING_SILENCE_PAD_MS = 1_200; // Synthetic silence sent after stop. Backend Deepgram VAD needs silence frames to fire SpeechFinal/UtteranceEnd and commit pending transcript
export const MAX_RECORDING_SIZE_BYTES = 3.5 * 1024 * 1024; // 3.5MB - gRPC limit is 4MB (batch only)

// PCM chunk size emitted by the AudioWorklet to upstream transport. 12000 samples
// = 250ms at 48kHz, the upper bound of Deepgram's recommended 20-250ms range.
// Larger chunks reduce HTTP overhead at the cost of slightly higher interim
// transcript latency.
export const PCM_BUFFER_SIZE = 12_000;

export const WAVEFORM_BAR_COUNT = 4;
export const WAVEFORM_FFT_SIZE = 256; // 128 frequency bins; smoothingTimeConstant handled in component
export const WAVEFORM_MIN_BAR_HEIGHT_PX = 4;
export const WAVEFORM_MAX_BAR_HEIGHT_PX = 20;
export const WAVEFORM_GAIN = 1.2; // Voice bins peak ~80-110 of 255; gentle boost without overdriving silence noise
export const SILENCE_RMS_THRESHOLD = 60; // 0-255 scale from getByteFrequencyData average over voice bins. Also gates the waveform bars: below this value bars stay at min height.

// Bins each bar samples from the FFT output. At fftSize=256 @ 48kHz each bin is ~187Hz.
// Ranges are log-spaced across the voice spectrum so each bar reacts to a distinct
// component of speech instead of all pulsing with the same low-frequency energy.
// Bar 0: ~187-750 Hz   (fundamentals)
// Bar 1: ~750-1875 Hz  (vowel formants)
// Bar 2: ~1875-3750 Hz (mid consonants)
// Bar 3: ~3750-7500 Hz (sibilants, high harmonics)
export const WAVEFORM_BAR_BIN_RANGES: ReadonlyArray<readonly [number, number]> = [
  [1, 4],
  [4, 10],
  [10, 20],
  [20, 40],
];

export const VOICE_API_HOSTS = new Map<Environment, string>([
  [Environment.LOCAL, 'voice-api.vendasta-local.com'],
  [Environment.DEMO, 'voice-demo.apigateway.co'],
  [Environment.PROD, 'voice-prod.apigateway.co'],
]);
